import { PropsWithChildren } from 'react';
import cn from 'classnames';
import { useOfferPageContext } from 'pages/offer/context';
import { Logos } from 'pages/offer/consts';
import x5LogoIcon from 'shared/icons/x5-logo.svg';
import { Typography, TypographyType } from './typography';
import { Spacing, SpacingDirection, SpacingSize } from './spacing';
import styles from './footer.module.scss';
import { IconsBlock } from '.';

export type FooterProps = PropsWithChildren & {
  className?: string;
};

/**
 * Footer
 * @param className
 */
export const Footer = ({ className }: FooterProps) => {
  const {
    userData: { businessUnit },
  } = useOfferPageContext();

  return (
    <Spacing size={SpacingSize.xsmall} direction={SpacingDirection.both} className={cn(styles.footer, className)}>
      <Typography type={TypographyType.h2}>Узнай нас лучше</Typography>

      <Spacing size={SpacingSize.medium} direction={SpacingDirection.both} className={cn(styles.iconsBlock, className)}>
        <IconsBlock className={styles.icons} classNameIconHabr={styles.iconHabr} />

        <Spacing size={SpacingSize.small} direction={SpacingDirection.both}>
          <img className={styles.businessUnitIcon} src={Logos[businessUnit.id]} />
          <img className={styles.iconX5} src={x5LogoIcon} />
        </Spacing>
      </Spacing>
    </Spacing>
  );
};
